// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"bs-lp20-src-pages-404-module-page-title"};